import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({ selector: '[removeImageTitleAttr]' })
export class RemoveImageTitleAttrDirective implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const img = this.el.nativeElement.querySelector('img');
    if (img && img.hasAttribute('title')) {
      this.renderer.removeAttribute(img, 'title');
    }
  }
}
